import type { ReactNode } from 'react';
import { memo } from 'react';
import { styled, Typography as MuiTypography, Popover, type SxProps, type Theme } from '@mui/material';

const Trigger = styled(MuiTypography)(() => ({
  cursor: 'pointer',
  display: 'inline-block',
  maxWidth: '100%',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

type FilePreviewPopoverProps = {
  label: string;
  open: boolean;
  anchorEl: HTMLElement | null;
  onMouseEnter: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave: () => void;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  onPopoverMouseEnter: () => void;
  onClose: () => void;
  children: ReactNode;
  triggerSx?: SxProps<Theme>;
};

const FilePreviewPopoverBase = ({
  label,
  open,
  anchorEl,
  onMouseEnter,
  onMouseLeave,
  onClick,
  onPopoverMouseEnter,
  onClose,
  children,
  triggerSx,
}: FilePreviewPopoverProps) => {
  return (
    <>
      <Trigger variant="subtitle2" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick} sx={triggerSx}>
        {label}
      </Trigger>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        disableScrollLock
        sx={{ pointerEvents: 'none' }}
        slotProps={{
          paper: {
            onMouseEnter: onPopoverMouseEnter,
            onMouseLeave,
            sx: {
              pointerEvents: 'auto',
              maxWidth: 'min(90vw, 720px)',
            },
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClick={(e) => e.stopPropagation()}>
        {children}
      </Popover>
    </>
  );
};

export const FilePreviewPopover = memo(FilePreviewPopoverBase);
